interface ShouldShowEditableTitleOptions {
    sectionComponent?: string | null
    elementParentFrameType?: string | null
}

const hiddenTitleParentFrameTypes = new Set(['row'])

const hiddenTitleSectionComponents = new Set<string>([])

export const shouldShowEditableTitle = ({
    sectionComponent,
    elementParentFrameType,
}: ShouldShowEditableTitleOptions) => {
    if (elementParentFrameType) {
        return !hiddenTitleParentFrameTypes.has(elementParentFrameType)
    }

    if (!sectionComponent) {
        return true
    }

    return !hiddenTitleSectionComponents.has(sectionComponent)
}
